<template>
  <v-dialog
    v-model="showDialog"
    persistent
    no-click-animation
    max-width="380"
    overlay-opacity="0.85"
    overlay-color="#000"
  >
    <v-card class="force-update-card text-center pb-6" rounded="xl">
      <div class="force-update-header d-flex align-center justify-center">
        <div class="force-update-icon d-flex align-center justify-center">
          <v-icon size="44" color="white">mdi-rocket-launch</v-icon>
        </div>
      </div>

      <v-card-title class="justify-center pt-8 pb-1">
        <span class="text-h5 font-weight-bold">{{ config.title || 'Update Required' }}</span>
      </v-card-title>

      <v-card-text class="px-8">
        <p class="body-1 mb-4">
          {{ config.message || 'A new version of DriverX is available. Please update the app to continue.' }}
        </p>
        <v-chip small outlined color="grey" class="mr-1">
          v{{ currentVersion }}
        </v-chip>
        <v-icon small class="mx-1">mdi-arrow-right</v-icon>
        <v-chip small color="primary">
          v{{ config.latestVersion || config.minVersion }}
        </v-chip>
      </v-card-text>

      <v-card-actions class="justify-center px-8">
        <v-btn
          block
          x-large
          color="primary"
          class="force-update-btn font-weight-bold"
          rounded
          @click="openStore"
        >
          <v-icon left>mdi-download</v-icon>
          Update Now
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForceUpdateDialog',
  data () {
    return {
      showDialog: false,
      config: {},
      currentVersion: process.env.VUE_APP_VERSION || '0.0.0'
    }
  },
  mounted () {
    // Only enforce updates inside the Cordova app.
    // The web build is always the latest version, so it is never blocked.
    if (!window.cordova) return
    this.checkVersion()
    // Re-check when the app comes back from the background,
    // so long-running sessions also get the update gate.
    document.addEventListener('resume', this.checkVersion, false)
  },
  beforeDestroy () {
    document.removeEventListener('resume', this.checkVersion, false)
  },
  methods: {
    async checkVersion () {
      try {
        const { data } = await axios.get('/app-version', {
          // cache-buster so a CDN/proxy never serves a stale config
          params: { t: Date.now() }
        })
        if (data && data.minVersion) {
          this.config = data
          this.showDialog = this.isOlder(this.currentVersion, data.minVersion)
        }
      } catch (e) {
        // Fail open: if the check can't run (offline / endpoint down),
        // never lock users out of the app.
        console.warn('App version check failed:', e)
      }
    },
    isOlder (installed, minimum) {
      const a = String(installed).split('.').map(n => parseInt(n, 10) || 0)
      const b = String(minimum).split('.').map(n => parseInt(n, 10) || 0)
      const len = Math.max(a.length, b.length)
      for (let i = 0; i < len; i++) {
        const x = a[i] || 0
        const y = b[i] || 0
        if (x < y) return true
        if (x > y) return false
      }
      return false
    },
    openStore () {
      const platform = (window.device && window.device.platform) || ''
      const isIos = platform === 'iOS' ||
        /iPad|iPhone|iPod/.test(navigator.userAgent)
      const url = isIos ? this.config.iosUrl : this.config.androidUrl
      if (url) {
        window.open(url, '_system')
      }
    }
  }
}
</script>

<style scoped>
.force-update-card {
  overflow: visible;
  padding-top: 44px;
}
.force-update-header {
  position: absolute;
  top: -44px;
  left: 0;
  right: 0;
}
.force-update-icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2d9a47 0%, #16652c 100%);
  box-shadow: 0 8px 24px rgba(45, 154, 71, 0.45);
  animation: force-update-pulse 2s ease-in-out infinite;
}
.force-update-btn {
  text-transform: none;
  letter-spacing: 0.3px;
}
@keyframes force-update-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}
</style>
